var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-0.039 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M.656,12A.618.618,0,0,1,.22,10.945L10.985.18a.617.617,0,0,1,.873.873L1.093,11.819A.619.619,0,0,1,.656,12Zm0,0",
    transform: "translate(0)",
    fill: "#5c5550"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M11.422,12a.613.613,0,0,1-.436-.181L.22,1.054A.617.617,0,0,1,1.093.18L11.858,10.946A.618.618,0,0,1,11.422,12Zm0,0",
    transform: "translate(0 0)",
    fill: "#5c5550"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICAgIDxnIGlkPSJjbG9zZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMDM5IDAuMDAxKSI+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMTE0IiBkYXRhLW5hbWU9IlBhdGggMTE0IiBkPSJNLjY1NiwxMkEuNjE4LjYxOCwwLDAsMSwuMjIsMTAuOTQ1TDEwLjk4NS4xOGEuNjE3LjYxNywwLDAsMSwuODczLjg3M0wxLjA5MywxMS44MTlBLjYxOS42MTksMCwwLDEsLjY1NiwxMlptMCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIgZmlsbD0iIzVjNTU1MCIvPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzExNSIgZGF0YS1uYW1lPSJQYXRoIDExNSIgZD0iTTExLjQyMiwxMmEuNjEzLjYxMywwLDAsMS0uNDM2LS4xODFMLjIyLDEuMDU0QS42MTcuNjE3LDAsMCwxLDEuMDkzLjE4TDExLjg1OCwxMC45NDZBLjYxOC42MTgsMCwwLDEsMTEuNDIyLDEyWm0wLDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiM1YzU1NTAiLz4KICAgIDwvZz4KPC9zdmc+";
export { SvgCloseHint as ReactComponent };